import { render } from "./HosPalPatientMain.vue?vue&type=template&id=6f8a382c&ts=true"
import script from "./HosPalPatientMain.ts?vue&type=script&lang=ts&external"
export * from "./HosPalPatientMain.ts?vue&type=script&lang=ts&external"

import "./HosPalPatientMain.scss?vue&type=style&index=0&lang=sass&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__